<mat-card>
  <mat-card-content>
    <fs-list [config]="listConfig">
      <fs-list-column
          name="name"
          title="Name"
          [sortable]="true">
        <ng-template
            fs-list-cell
            let-row="row">
          <a
              (click)="openPerson(row)"
              style="cursor: pointer;">
            {{ row.name || '—' }}
          </a>
        </ng-template>
      </fs-list-column>
      <fs-list-column
          name="email"
          title="Email"
          [sortable]="false">
        <ng-template
            fs-list-cell
            let-row="row">
          {{ row.email || '—' }}
        </ng-template>
      </fs-list-column>
      <fs-list-column
          name="account"
          title="Account"
          [sortable]="false">
        <ng-template
            fs-list-cell
            let-row="row">
          @if (row.account) {
            <fs-badge
              [image]="row.account.avatar?.tiny"
              [tooltip]="row.account.name">
            </fs-badge>
          }
        </ng-template>
      </fs-list-column>
      <fs-list-column
          name="project"
          title="Project"
          [sortable]="false">
        <ng-template
            fs-list-cell
            let-row="row">
          @if (row.project) {
            <fs-badge
              [image]="row.project.avatar?.tiny"
              [tooltip]="row.project.name">
            </fs-badge>
          }
        </ng-template>
      </fs-list-column>
      <fs-list-column
          name="voice"
          title="Voice"
          [sortable]="false">
        <ng-template
            fs-list-cell
            let-row="row">
          @if (row.voiceSampleCount) {
            <fs-popover
                [template]="voicePopover"
                size="small">
              <fs-chip
                  backgroundColor="#e8f5e9"
                  size="tiny">
                Fingerprinted
              </fs-chip>
            </fs-popover>
            <ng-template #voicePopover>
              <div>
                <strong>
                  Samples:
                </strong>
                {{ row.voiceSampleCount || 0 }}
              </div>
              @if (row.voiceDimensions) {
                <div>
                  <strong>
                    Dimensions:
                  </strong>
                  {{ row.voiceDimensions }}
                </div>
              }
            </ng-template>
          }
        </ng-template>
      </fs-list-column>
      <fs-list-column
          name="createDate"
          title="Created"
          [sortable]="true">
        <ng-template
            fs-list-cell
            let-row="row">
          <fs-date-ago [date]="row.createDate"></fs-date-ago>
        </ng-template>
      </fs-list-column>
    </fs-list>
  </mat-card-content>
</mat-card>